export abstract class UrlHelpers {
  public static getParamString(key: string, values: number[] | string[]) {
    let paramString = '';
    values.forEach((value: number | string) => {
      paramString += `&${key}=${value}`;
    });
    return paramString.substring(1);
  }
}
